import { RotateIcon } from "@workspace/frontend-ui";
import type { FC } from "react";

const RotateScreenIcon: FC = () => (
  <div className="w-full flex justify-center">
    <RotateIcon />
  </div>
);

export default RotateScreenIcon;
